import React, { useEffect } from 'react';
import InputSearch from './InputSearch';
import {getHighlightString} from '../../utills';
import FormCheck from 'jd-library/FormCheck';
import style from './checkbox-list.scss';

export default function CheckboxList(props) {
    const [searchText, setSearchText] = React.useState('');
    const [searchResults, setSearchResults] = React.useState(props.subMenu);

    const onValChange = (e, current) => {
        if(!props.isMultiSelect)
            resetAllFilter();
        current.isChecked = e.currentTarget.checked;
        let value = [];
        props.subMenu.map((val) => {
            val.isChecked && value.push(val.value);
        })
        if(!value.length)
            value = null;
        props.onChangeCB && props.onChangeCB(props.serviceKey, value);
    }

    const onInputChange = (e) => {
        let searchText = e ? e.currentTarget.value : '';
        let timer = searchText ? 0 : 300;
        setTimeout(() => {
            setSearchText(searchText);
            let results = props.subMenu.filter((item) => (
				shouldItemRender(item, searchText)
            ))
            setSearchResults(results);
        }, timer);
    }

    const shouldItemRender = (item, value) => {
        let matchRegex = new RegExp(value, "i");
        return matchRegex.test(item.rawLabel)
    }

    const resetAllFilter = () => {
        props.subMenu.map((cur) => {
            cur.isChecked = false
        });
    }

    useEffect(() => {
        setSearchResults(props.subMenu);
    }, [props.subMenu])

    useEffect(() => {
        setSearchText('');
    }, [props.label])

    return (
        <div className={`${props.className} ${style['checkbox-container']}`}>
            {props.hasSearch && (
                <InputSearch
                    ref={props.searchRef?props.searchRef:null}
                    placeholder={props.placeholder}
                    className={style['filter-input']}
                    onInputChange={(e) => onInputChange(e)}
                    searchText={searchText}
                />
            )}
            {searchResults.length ? searchResults.map((cur, index) => {
                let results;
                if(props.hasSearch){
                    results = getHighlightString({
                        searchKey: searchText,
                        searchResult: cur.rawLabel,
                        className: style['search-highlight']
                    });
                }
                return (
                    <div key={index}>
                    <FormCheck
                        key={index}
                        label={props.hasSearch ? <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%'}}> <span dangerouslySetInnerHTML={{__html: results}}></span><span className={style['prod-count']}>{cur.count}</span></div>: <span>{cur.label}</span>}
                        checked={cur.isChecked}
                        value={cur.value}
                        type={props.variant}
                        onChange={(e) => onValChange(e, cur)}
                        className={style['checkbox-holder']}
                        labelClass={style['checkbox-label']}
                        labelPosition={props.labelPosition ? props.labelPosition : "before"}
                    />
                    <div className={style['border-bottom']}></div>
                    </div>
                )
            }) : <div className={style['no-result']}>
                No Results Found
            </div>}
        </div>
    )
}